import {useEffect, useState} from "react"

const useTestimonials = ()=>{

    const [testimonialData, setTestimonialData] = useState(null)

useEffect(()=>{
fetchData();
}, [])

const jsonPath = process.env.REACT_APP_CDN + "nonqmTestimonials/testimonial.json" 

const fetchData = async() => {
    try{
    const data = await fetch(jsonPath);
    const jsonData = await data.json();
    setTestimonialData(jsonData);
    console.log(jsonData);
    } catch (error){
        console.log("Problem fetching data", error)
    }
}

    return testimonialData;
}

export default useTestimonials;